// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NoValueCell-base__uEUU1{display:flex;align-items:center;justify-content:flex-start;width:var(--size-full);height:var(--size-12);padding:var(--size-0) var(--size-4);color:var(--text-placeholder);border-bottom:var(--size-px) solid var(--gray-a3);font:var(--font-body-400-compact);font-feature-settings:var(--feature-settings-body-400-compact);letter-spacing:var(--letter-spacing-body-400-compact)}.NoValueCell-rightAligned__LNMNr{justify-content:flex-end}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "NoValueCell-base__uEUU1",
	"rightAligned": "NoValueCell-rightAligned__LNMNr"
};
export default ___CSS_LOADER_EXPORT___;
